// TeethwhitenData.ts

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string;
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
    whyChooseUs?: {
        heading: string;
        description: string;
    };
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const teethwhiten: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    en: {
        "url": "",
        "meta": {
            "title": "Teeth Whitening Dubai",
            "description": "Professional teeth whitening treatments in Dubai for a brighter, more confident smile using advanced technology.",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["Home", "Services", "Teeth Whitening Dubai"],
        "hero": {
            "title": "Teeth Whitening Dubai",
            "subtitle": "Unlock the Key to a Bright and Beautiful Smile",
            "description": "Are you unsatisfied with your discolored or stained teeth? You're not alone! Your smile is the first thing people notice about you. Thus, good hygiene requires good hygiene and a perfect smile that gives you confidence and enhances your appearance."
        },
        "howItWorks": {
            "title": "Teeth whitening in Dubai: Why to opt your bright smile Partner?",
            "description": "Dubai is synonymous with luxury and innovation and an abundance of world class amenities. It's not only a premier tourist destination, it's also a center for high-quality dental care and aesthetics."
        },
        "procedureSteps": {
            "heading": "Procedure Of Teeth Whitening Step By Step",
            "para": "Teeth whitening is safe, fast, and a very effective way to get results you can see after just one visit.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "The process begins with a comprehensive analysis of your teeth to determine whether you're a suitable candidate for the procedure.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Preparation",
                    "desc": "Plaques and tartar on the teeth are removed, and the gums are protected from the hydrogen peroxide or other whitening agents.",
                    "icon": "fa-solid fa-teeth-open"
                },
                {
                    "title": "Application of Whitening Gel",
                    "desc": "This involves applying a high-concentration bleaching gel, typically hydrogen peroxide or carbamide peroxide, to the teeth.",
                    "icon": "fa-solid fa-spray-can-sparkles"
                },
                {
                    "title": "Activation",
                    "desc": "In certain situations, a specialized light or laser activates the whitening agent, expediting the process.",
                    "icon": "fa-solid fa-lightbulb"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Teeth Whitening",
            "subheading": "",
            "para": "Teeth whitening enhances your appearance immensely, but the benefits go beyond mere aesthetics.",
            "items": [
                {
                    "title": "Enhanced confidence",
                    "desc": "",
                    "icon": "fa-solid fa-face-smile-beam"
                },
                {
                    "title": "Improved oral health",
                    "desc": "",
                    "icon": "fa-solid fa-tooth"
                },
                {
                    "title": "A Brighter Smile",
                    "desc": "",
                    "icon": "fa-solid fa-sparkles"
                },
                {
                    "title": "Healthier mouth",
                    "desc": "",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "Customized treatments",
                    "desc": "",
                    "icon": "fa-solid fa-clipboard-user"
                },
                {
                    "title": "Fast results",
                    "desc": "",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Teeth whitening results vary, which is why not all individuals are perfect candidates for a specific whitening approach.",
            "items": [
                {
                    "title": "Discolored Teeth",
                    "desc": "If your teeth are yellowish or dull due to foods, drinks, or tobacco use.",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "Healthy Teeth & Gums",
                    "desc": "People with no serious dental problems, like gum disease or untreated cavities, are good candidates.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "No Allergic Reactions",
                    "desc": "Those who don't have allergies to bleaching agents such as hydrogen peroxide.",
                    "icon": "fa-solid fa-allergies"
                }
            ]
        },
        "preparationTips": {
            "heading": "Teeth whitening treatment preparation",
            "subheading": "",
            "para": "A key requirement is that you prepare well so that you can get the best results and reduce any possibility of sensitivity when undergoing the whitening process.",
            "items": [
                {
                    "title": "Brush and Floss",
                    "desc": "Do Brush and Floss Before the Procedure",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "Avoid Foods and Drinks",
                    "desc": "Avoid foods and drinks that can stain teeth before treatment",
                    "icon": "fa-solid fa-utensils-slash"
                },
                {
                    "title": "Address Dental Issues",
                    "desc": "Address any Dental Issues before whitening",
                    "icon": "fa-solid fa-teeth-open"
                },
                {
                    "title": "Discuss Sensitivity",
                    "desc": "Discuss Sensitivity Concerns with your dentist",
                    "icon": "fa-solid fa-hand-holding-medical"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Compared to DIY teeth whitening, professional teeth whitening gives visible results right after the dental appointment.",
            "items": [
                {
                    "title": "Immediate Results",
                    "desc": "Most patients walk out with smiles several shades whiter than when they come in.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Long-lasting",
                    "desc": "If followed by proper aftercare, these results are maintained for a long time.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": ""
                }
            ]
        },
        "faqData": {
            "heading": "Common questions about professional teeth whitening treatments",
            "subheading": "",
            "items": [
                {
                    "question": "How long does teeth whitening last?",
                    "answer": "Results vary based on diet and oral hygiene. Avoiding stain-causing foods/drinks helps maintain whiteness longer."
                },
                {
                    "question": "Is the whitening process painful?",
                    "answer": "Most experience no discomfort, though some may feel mild sensitivity that subsides within 1-2 days."
                },
                {
                    "question": "Can teeth whitening damage my teeth?",
                    "answer": "No, professional whitening under dental supervision is safe and doesn't damage tooth enamel."
                },
                {
                    "question": "How many sessions are needed for optimal results?",
                    "answer": "Most see excellent results after one session, though additional sessions may be recommended for higher whitening."
                },
                {
                    "question": "Is teeth whitening safe?",
                    "answer": "Yes, we use FDA-approved whitening products applied by experienced dentists for safe, effective results with minimal sensitivity."
                }
            ]
        },
        "treatmentAreas1": [

        ],
        "treatmentAreas2": [

        ]
    },
    ar: {
        "url": "",
        "meta": {
            "title": "تبييض الأسنان في دبي",
            "description": "خدمات تبييض الأسنان الاحترافية في دبي باستخدام أحدث التقنيات للحصول على ابتسامة مشرقة وجذابة",
            "robots": "",
            "canonical": "",
            "og": {}
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "تبييض الأسنان في دبي"],
        "hero": {
            "title": "تبييض الأسنان في دبي",
            "subtitle": "اكتشف السر وراء ابتسامة مشرقة وجذابة",
            "description": "هل تشعر بعدم الرضا عن اصفرار أسنانك أو تصبغها؟ أنت لست وحدك! فالابتسامة هي أول ما يلاحظه الآخرون بك."
        },
        "howItWorks": {
            "title": "لماذا تختار تبييض الأسنان في دبي؟",
            "description": "تُعرف دبي بالفخامة والابتكار، وتوفر وسائل للراحة عالمية المستوى، حيث إنها ليست مجرد وجهة سياحية رائدة، بل أيضًا مركز مرموق لطب الأسنان والعناية بالمظهر الجمالي."
        },
        "procedureSteps": {
            "heading": "خطوات تبييض الأسنان",
            "para": "نعتمد في ايليت بودي هوم على الإجراءات الدقيقة والآمنة التي تمنحك نتائج ملحوظة من أول جلسة.",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "نبدأ بتقييم شامل لحالة أسنانك للتأكد من أنك مؤهل لهذا الإجراء.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "التحضير",
                    "desc": "تُنظف الأسنان من البلاك والجير، مع حماية اللثة من بيروكسيد الهيدروجين أو أي مواد مبيضة أخرى.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "استخدام چل التبييض",
                    "desc": "يُستخدم چل عالي التركيز على الأسنان يحتوي عادةً على بيروكسيد الهيدروجين أو بيروكسيد الكارباميد.",
                    "icon": "fa-solid fa-spray-can-sparkles"
                },
                {
                    "title": "التنشيط",
                    "desc": "يُستخدم ضوء خاص أو ليزر في بعض الحالات لتنشيط مادة التبييض وتسريع النتيجة.",
                    "icon": "fa-solid fa-lightbulb"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد تبييض الأسنان",
            "subheading": "",
            "para": "لا يمنحك تبييض الأسنان ابتسامة مشرقة فقط، بل ينعكس إيجابيًا على جوانب كثيرة من حياتك.",
            "items": [
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "",
                    "icon": "fa-solid fa-face-smile-beam"
                },
                {
                    "title": "تحسين صحة الفم",
                    "desc": "",
                    "icon": "fa-solid fa-tooth"
                },
                {
                    "title": "نتائج سريعة",
                    "desc": "",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "علاج غير جراحي",
                    "desc": "",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "مظهر أكثر شبابًا",
                    "desc": "",
                    "icon": "fa-solid fa-child-reaching"
                },
                {
                    "title": "تأثير نفسي إيجابي",
                    "desc": "",
                    "icon": "fa-solid fa-brain"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "تختلف نتائج تبييض الأسنان من شخص لآخر، ولذلك لا يُعد جميع الأفراد مرشحين مثاليين لكل نوع من أنواع تبييض الأسنان.",
            "items": [
                {
                    "title": "تصبغ الأسنان",
                    "desc": "إذا كانت أسنانك باهتة أو صفراء بسبب تناول بعض الأطعمة أو المشروبات أو التدخين.",
                    "icon": "fa-solid fa-teeth"
                },
                {
                    "title": "صحة الفم الجيدة",
                    "desc": "الأشخاص الذين لا يعانون من مشكلات صحية في الأسنان مثل أمراض اللثة أو التسوس غير المعالج.",
                    "icon": "fa-solid fa-heart-pulse"
                },
                {
                    "title": "عدم التحسس من المواد",
                    "desc": "يجب ألا يكون لديك أي رد فعل تحسسي تجاه مواد التبييض مثل بيروكسيد الهيدروجين.",
                    "icon": "fa-solid fa-allergies"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل الجلسة",
            "subheading": "",
            "para": "يُعد التحضير الجيد خطوة أساسية لضمان أفضل النتائج وإجراء بدون حساسية.",
            "items": [
                {
                    "title": "تنظيف الأسنان",
                    "desc": "قم بتنظيف الأسنان بالفرشاة والخيط قبل الموعد.",
                    "icon": "fa-solid fa-broom"
                },
                {
                    "title": "تجنب المأكولات",
                    "desc": "تجنب الأطعمة والمشروبات التي قد تسبب التصبغات.",
                    "icon": "fa-solid fa-utensils-slash"
                },
                {
                    "title": "علاج المشكلات",
                    "desc": "عالج أي مشكلات في الأسنان قبل البدء.",
                    "icon": "fa-solid fa-teeth-open"
                },
                {
                    "title": "مناقشة الحساسية",
                    "desc": "ناقش أي مخاوف تتعلق بالحساسية مع طبيب الأسنان.",
                    "icon": "fa-solid fa-comment-medical"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "يمنحك تبييض الأسنان الاحترافي نتائج مرئية مباشرةً بعد الجلسة، مقارنةً بطرق التبييض المنزلية.",
            "items": [
                {
                    "title": "نتائج فورية",
                    "desc": "يغادر معظم المرضى العيادة بابتسامة أفتح بعدة درجات من لون أسنانهم قبل الجلسة.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "يمكن الحفاظ على هذه النتائج لفترة طويلة، مع الالتزام بالتعليمات الخاصة بالعناية بعد التبييض.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "",
                    "desc": "",
                    "icon": ""
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "أسئلة مكررة حول تبييض الأسنان",
            "items": [
                {
                    "question": "كم تدوم نتائج تبييض الأسنان؟",
                    "answer": "تختلف النتائج حسب النظام الغذائي ونظافة الفم. تجنب الأطعمة والمشروبات المسببة للتصبغات يساعد في الحفاظ على النتائج لفترة أطول."
                },
                {
                    "question": "هل عملية التبييض مؤلمة؟",
                    "answer": "معظم المرضى لا يشعرون بأي ألم، وقد يشعر البعض بحساسية خفيفة تزول خلال يوم أو يومين."
                },
                {
                    "question": "هل يمكن أن يضر التبييض بأسناني؟",
                    "answer": "لا، التبييض الاحترافي تحت إشراف طبي آمن ولا يضر بمينا الأسنان."
                },
                {
                    "question": "كم جلسة أحتاج للحصول على أفضل النتائج؟",
                    "answer": "معظم المرضى يحصلون على نتائج ممتازة بعد جلسة واحدة، وقد ينصح الطبيب بجلسات إضافية لتبييض أكثر."
                },
                {
                    "question": "هل تبييض الأسنان آمن؟",
                    "answer": "نعم، نستخدم منتجات معتمدة من الهيئات الصحية وتطبق بواسطة أطباء أسنان خبراء لضمان نتائج آمنة وفعالة."
                }
            ]
        },
        "treatmentAreas1": [
        ],
        "treatmentAreas2": [
        ],
        "whyChooseUs": {
            "heading": "لماذا تختار عيادات ايليت بودي هوم؟",
            "description": "نركز في عيادات ايليت بودي هوم على تقديم خدمات تبييض الأسنان بأعلى جودة، باستخدام أحدث التقنيات الطبية وأكثرها أمانًا وفاعلية."
        }
    },
    shared: {
        images: {
            main: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/ebh-services-uae-39-scaled.jpg",
            beforeAfter: [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/127.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/128.webp",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/129.webp"
            ],
            introductionImage: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Tooth-Filling-Service-Page.jpg"
        },
        product: {
            id: 25,
            title: "Teeth Whitening",
            price: 1500,
            description: "Professional teeth whitening treatments in Dubai for a brighter, more confident smile using advanced technology."
        }
    }
};